module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_1083_bright_canary_yellow.ff5c4a92.jpg";